'use client';

import { getItem } from '@alltrails/session-storage';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import ScrollLimit from '@alltrails/user-auth/components/ScrollLimit/ScrollLimit';

type ScrollLimitWrapperProps = {
  isScrollLimitActive: boolean;
  deeplinkData: DeeplinkData;
};

export const isSessionSeoTraffic = (): boolean => {
  const sessionAttribution = getItem<{ referring_domain?: string }>('sessionAttribution');

  if (!sessionAttribution) {
    return false;
  }

  return sessionAttribution.referring_domain?.includes('google') ?? false;
};

const ScrollLimitWrapper = ({ isScrollLimitActive, deeplinkData }: ScrollLimitWrapperProps) => {
  return isScrollLimitActive || isSessionSeoTraffic() ? <ScrollLimit deeplinkData={deeplinkData} /> : null;
};

export default ScrollLimitWrapper;
